"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePostIdNavigation = initializePostIdNavigation;
exports.initializeUrlNavigation = void 0;

var _qs = _interopRequireDefault(require("qs"));

/**
 * Initializes the URL navigation behavior.
 */
var initializeUrlNavigation = function initializeUrlNavigation() {
  initializePostIdNavigation();
};
/**
 * Initializes the post ID navigation.
 * When the post ID is present in the URL, it will be added to the hash.
 * This matches the registered pattern for the post ID.
 *
 * @example
 * ```
 * /path?postid=123
 * ```
 *
 * Will navigate to:
 * ```
 * /path#post123
 */


exports.initializeUrlNavigation = initializeUrlNavigation;

function initializePostIdNavigation() {
  var searchQuery = window.location.search;

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  var postId = queryParameters.postid;
  if (postId) window.location.hash = '#post' + postId;
}